import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Providing settings releated data and functions */

@Injectable({
  providedIn: 'root'
})
export class SettingsService {

  public ObservableLanguage: BehaviorSubject<string> = new BehaviorSubject("en");

  constructor() { }

  public getTitleMaxLength():number {
    return 100;
  }

  /*public getReleaseNotesMaxLength():number {
    return 1000;
  }*/

  public getDescriptionMaxLength(): number{
    return 255;
  }

  public getIdMaxValue(): number{
    return 1000000000;
  }

  public getIdMaxLength(): number{
    return 9;
  }

  public getComponentIdLength(): number{
    return 2;
  }

  public getItemsPerPage(): number{
    return 50;
  }

  /** Wheel Circumference min in mm */
  public getWheelCircumferenceMin(): number{
    return 1500;
  }

  /** Wheel Circumference max in mm */
  public getWheelCircumferenceMax(): number{
    return 2500;
  }

  /** Date Of Next Service min in days */
  public getDateOfNextServiceMin(): number{
    return 0;
  }

  /** Date Of Next Service max in days */
  public getDateOfNextServiceMax(): number{
    return 9999;
  }

  /** ODO Of Next Service min in km */
  public getOdoOfNextServiceMin(): number{
    return 0;
  }

  /** ODO Of Next Service max in km */
  public getOdoOfNextServiceMax(): number{
    return 9999;
  }

  /** Light reserved area min in mAh */
  public getLightReservedAreaMin(): number{
    return 0;
  }

  /** Light reserved area max in mAh */
  public getLightReservedAreaMax(): number{
    return 9999;
  }

  /** Lower battery discharge limit min in percent */
  public getLowerBatteryDischargeLimitMin(): number{
    return 0;
  }

  /** Lower battery discharge limit max in percent */
  public getLowerBatteryDischargeLimitMax(): number{
    return 20;
  }

  /** Upper battery charge limit min in percent */
  public getUpperBatteryChargeLimitMin(): number{
    return 80;
  }

  /** Upper battery charge limit max in percent */
  public getUpperBatteryChargeLimitMax(): number{
    return 100;
  }

  /** Max support speed min in km/h */
  public getMaxSupportSpeedMin(): number{
    return 5;
  }

  /** Max support speed max in km/h */
  public getMaxSupportSpeedMax(): number{
    return 45;
  }

  /** Get paginations pre definied values */
  public getPaginationValues(): number[] {
    return [20, 50, 100, 200];
  }
}
